import * as griddy from './griddy'
import * as juice from './juice'
import * as flagshipPower from './flagship-power'
import * as think from './think'
import * as abundance from './abundance'
import * as mothership from './mothership'
import * as branchEnergy from './branch-energy'
import * as fanfare from './fanfare'

// selected profile make selection based on command line arguments or build config
// eslint-disable-next-line import/no-mutable-exports
let selectedProfile

switch (process.env.REACT_APP_PROFILE_NAME) {
  case 'griddy': {
    selectedProfile = griddy
    break
  }

  case 'juice': {
    selectedProfile = juice
    break
  }

  case 'flagship-power': {
    selectedProfile = flagshipPower
    break
  }

  case 'think': {
    selectedProfile = think
    break
  }

  case 'abundance': {
    selectedProfile = abundance
    break
  }

  case 'mothership': {
    selectedProfile = mothership
    break
  }

  case 'branch-energy': {
    selectedProfile = branchEnergy
    break
  }

  case 'fanfare': {
    selectedProfile = fanfare
    break
  }

  default: {
    selectedProfile = griddy
  }
}

export const color = {
  ...selectedProfile.color,
}

export const theme = {
  ...selectedProfile.theme,
}

export const font = {
  ...selectedProfile.font,
  fontFace: selectedProfile.fontFace,
}

export const logoConfig = {
  ...selectedProfile.logoConfig,
}

export const companyInfo = {
  ...selectedProfile.companyInfo,
}

export const assets = {
  ...selectedProfile.assets,
}

export const features = {
  ...selectedProfile.features,
}

export const size = {
  ...selectedProfile.size,
}

export default selectedProfile
